export const siteMeta = {
  name: '故纸瓜档',
  slogan: '陈年旧瓜 · 考古重读',
  tagline: '把尘封往事翻出来，重新读一遍当年真相。',
  domain: 'https://bdnsv.cn',
  email: 'tougao@guzhiguadang.example.com',
  foundedYear: 2016,
  description:
    '故纸瓜档是一个专注娱乐圈陈年旧瓜与历史爆料考古重读的内容站。我们旧事重提、考古重读，重新审视尘封往事背后的当年真相，为你还原八卦爆料中那些被忽略的细节与反转。',
  keywords:
    '八卦爆料,八卦爆料陈年旧瓜,八卦爆料考古重读,八卦爆料历史爆料,八卦爆料旧事重提,八卦爆料当年真相,八卦爆料尘封往事',
};

export interface Category {
  slug: string;
  name: string;
  short: string;
  desc: string;
  count: number;
  accent: 'primary' | 'accent' | 'secondary' | 'foreground';
}

export const categories: Category[] = [
  {
    slug: 'chennian-gua',
    name: '陈年旧瓜',
    short: '旧瓜',
    desc: '把十年前二十年前的八卦翻出来，看看当年没吃明白的瓜，如今换一副口味重品。',
    count: 48,
    accent: 'primary',
  },
  {
    slug: 'kaogu-chongdu',
    name: '考古重读',
    short: '考古',
    desc: '像考古一样逐帧回看旧访谈、旧综艺、旧报道，发现当年根本没人注意的细节。',
    count: 36,
    accent: 'accent',
  },
  {
    slug: 'lishi-baoliao',
    name: '历史爆料',
    short: '史爆',
    desc: '把被时间冲淡的猛料重新归档，梳理前因后果，还原一段有头有尾的完整故事。',
    count: 29,
    accent: 'secondary',
  },
  {
    slug: 'jiushi-chongti',
    name: '旧事重提',
    short: '重提',
    desc: '旧事重提并非翻黑历史，而是把当年没讲完的话，放到今天的新语境里补上句点。',
    count: 41,
    accent: 'foreground',
  },
  {
    slug: 'dangnian-zhenxiang',
    name: '当年真相',
    short: '真相',
    desc: '在尘封往事中寻找当年的公开答案，让每一条八卦爆料都能追到它真正的出处。',
    count: 33,
    accent: 'accent',
  },
];

export interface TagCloud {
  name: string;
  count: number;
}

export const tagCloud: TagCloud[] = [
  { name: '综艺考古', count: 26 },
  { name: '旧访谈', count: 19 },
  { name: '颁奖礼名场面', count: 15 },
  { name: '绯闻澄清', count: 22 },
  { name: '幕后制作', count: 17 },
  { name: '春晚旧闻', count: 12 },
  { name: '选秀考古', count: 14 },
  { name: '老照片', count: 21 },
  { name: '翻车现场', count: 13 },
  { name: '口碑反转', count: 18 },
  { name: '舆论往事', count: 16 },
  { name: '记者手记', count: 11 },
];

export const stats = [
  { value: '1800+', label: '篇旧瓜档案' },
  { value: '26万+', label: '读者考古讨论' },
  { value: '9年', label: '持续重读与更新' },
  { value: '5大', label: '栏目矩阵' },
];